export default from './BuyerRegistration';



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/BuyerRegistration/index.js